import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";
import { Renraku, RenrakuDetail, RenrakuForList, RenrakuOptions, SearchItem } from "@/types/KaisyaRenraku";

export class RenrakuApi extends BaseApi {

  /**
   * 会社連絡を新規登録します
   * @param params
   * @returns
   */
  public async createRenraku(params: Renraku): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/renraku/create`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /** 会社連絡を取得します */
  public async getRenrakuList(): Promise<RenrakuForList[]> {
    try {
      const res = await this.get<RenrakuForList[]>(Config.API_URL + `/renraku/list`);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /** 会社連絡宛先ユーザーを取得します */
  public async getRenrakuUserList(): Promise<any> {
    try {
      return await this.get(Config.API_URL + `/renraku/userlist`);
    } catch (e: any) {
      throw e;
    }
  }

  /**
  * 会社連絡で使用するオプションを取得します（オプション値）
  * @returns
  */
  public async getAllOptions(): Promise<RenrakuOptions> {
    try {
      const res = await this.get<RenrakuOptions>(Config.API_URL + '/renraku/options/all');
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /** 検索条件に合う会社連絡を取得します */
  public async getRenrakuListForSearch(req: SearchItem): Promise<any> {
    try {
      const res = await this.post(Config.API_URL + `/renraku/search`, req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /** 会社連絡の詳細を取得します */
  public async getRenrakuDetail(oshiraseId: number): Promise<RenrakuDetail> {
    try {
      const res = await this.post<RenrakuDetail>(Config.API_URL + `/renraku/detail`, { oshiraseId });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /** 会社連絡の詳細を取得します */
  public async getRenrakuReadList(oshiraseId: number): Promise<any> {
    try {
      const res = await this.post(Config.API_URL + `/renraku/readlist`, { oshiraseId });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }
}
